@if (props.readonly) {
  <new-ui-wrapper-readonly [label]="props.resultLabel" [value]="languageLevelLabel" />

  <new-ui-wrapper-readonly
    [label]="props.dateLabel"
    [value]="
      exam?.examDateAndTime?.hasTime
        ? (exam?.examDateAndTime?.date | appDateTime)
        : (exam?.examDateAndTime?.date | appDate)
    "
  />
} @else {
  <div class="form">
    <p-floatlabel [dt]="props.dt?.components?.floatlabel" [class.col-span-6]="!props.readonly" variant="in">
      <input pInputText [ngModel]="languageLevelLabel" [readonly]="true" [fluid]="true" />

      <label>
        {{ props.resultLabel }}
      </label>
    </p-floatlabel>

    <p-floatlabel [dt]="props.dt?.components?.floatlabel" [class.col-span-6]="!props.readonly" variant="in">
      <p-datepicker
        [dt]="props.dt?.components?.datepicker"
        [ngModel]="exam?.examDateAndTime?.date"
        [showTime]="exam?.examDateAndTime?.hasTime"
        [readonlyInput]="true"
        [showOnFocus]="false"
        [fluid]="true"
        appendTo="body"
      />

      <label>
        {{ props.dateLabel }}
      </label>
    </p-floatlabel>
  </div>
}
